import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const WorkScheduleService = {
    getAllJourneys: async () => axios.get(API_KEEPER + `/work-schedule/get-all-journeys`).then((data) => data).catch((err) => { throw err }),
    getAllAvailableJourneys: async () => axios.get(API_KEEPER + `/work-schedule/get-enabled-journeys`).then((data) => data).catch((err) => { throw err }),
    toggleJourney: async (data) => axios.put(API_KEEPER + `/work-schedule/toggle-journeys`, data).then((data) => data).catch((err) => { throw err }),
};

export default WorkScheduleService;